export default __webpack_public_path__ + "static/media/MT3_activations_XZ.048f0387.png";